
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from '../Modal/Modal'
import css from './LoadingModal.module.css';

const LoadingModal = ({
    isBusy,
    loadingText
}) => {
    if (!isBusy) {
        return null;
    }

    return (
        <Modal>
            <div data-testid="loading-modal-component" className={classnames(css.root, 'container-fluid p-0 pb-3 w-50')}>
                <div className="row m-0">
                    <div className="col-12 p-5">
                        <h2 className={classnames(css.txt, 'text-center')}>{loadingText}</h2>
                    </div>
                    <div className="col-12 pb-5 text-center">
                        <div className={css.ldsSpinner}>
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                            <div />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

LoadingModal.propTypes = {
    isBusy: PropTypes.bool.isRequired,
    loadingText: PropTypes.string.isRequired,
};


export default LoadingModal;
